import { ModelBase } from '../../core/model/model-base';

export class LogRecord extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.shortText = model.shortText;
      this.createdAt = model.createdAt;
      this.userName = model.userName;
      this.texts = Array.isArray(model.texts) ? model.texts : [];
    }
  }
  get fullText(): string {
    let text = '';
    for (let t of this.texts) {
      text = text + (text === '' ? '' : ',\n ') + t;
    }
    return text;
  }
  shortText: string;
  createdAt: Date;
  userName: string;
  texts: string[];
}
